import './App.css';
import SignupPage from './pages/SignupPage/SignupPage';
import 'bootstrap/dist/css/bootstrap.css';
import briefcase from './assets/briefcase.svg';
import certificate from './assets/certificate.svg';
// import logo from './assets/logo.svg'
import logo from './assets/SamarthLogo.png'
import banner from './assets/SamarthBanner.jpg'
import { useState } from 'react';
import SuccessModal from './components/SuccessModal/SuccessModal';

function App() {
  const [showSignupModal, setShowSignupModal] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [candidateId, setCandidateId] = useState(null)
  const [responseMessage, setResponceMessage] = useState(null)

  return (
    <div className="container-fluid main_container">
      <header className="text-center">
        <img className='homeLogo' src={logo} alt="logo" />
        <h2>Retail Samarth</h2>
      </header>
      <main>
        <section className="bannerRow">
        <img className='samarthBanner' src={banner} alt="logo" />
          {/* <div className="vision-Section background-svg"> */}
            {/* <div className="frame-2"> */}
              {/* <div className="rectangle"></div> */}
              {/* <div className="our-vision">OUR VISION</div> */}
              {/* <div className="rectangle-2"></div> */}
            {/* </div> */}
            {/* <div className="text-snippet">
              <p>
                We're committed to skilling 2 Lakhs Indian
              </p>
              <p>
                youth every year and making them job ready
              </p>
            </div> */}
          {/* </div> */}
        </section>
        <section>
          <h3 className="text-center registration-section-heading">Why should you register with us?</h3>
          <div className="row registration-details m-auto">
            <div className="col-md-6">
              <div className="row">
                <div className="col-md-2 align-self-center">
                  <img src={briefcase} className="img-fluid" alt="brief case" />
                </div>
                <div className="col-md-10">
                  <p className="hero-text">Unlock a world of opportunities</p>
                  <p className="sub-hero-text">1.5L+ annual hiring through this platform</p>
                </div>
              </div>
            </div>
            {/* <!-- Second Column --> */}
            <div className="col-md-6">
              <div className="row">
                <div className="col-md-2 align-self-center">
                  <img src={certificate} className="img-fluid" alt="certificate" />
                </div>
                <div className="col-md-10">
                  <p className="hero-text">Up-to-date Industry relevant certification</p>
                  <p className="sub-hero-text">Designed by the industry leaders</p>
                </div>
              </div>
            </div>
          </div>
        </section>
        <div className="row justify-content-center mt-5 sign-up-cta">
          {/* setShowFaceRegistrationModal need to be changed later */}
          <button onClick={() => setShowSignupModal(true)} className="btn btn-dark">Sign Up </button>
          <p className="col-lg-12 text-center">Sign up for free by providing your basic details</p>
        </div>
      </main>
      {
        showSignupModal && (
          <SignupPage
            showSignupModal={showSignupModal}
            setShowSignupModal={setShowSignupModal}
            setShowSuccessModal={setShowSuccessModal}
            setCandidateId={setCandidateId}
            setResponceMessage={setResponceMessage}
          />
        )
      }
      {
        showSuccessModal && (
            <SuccessModal
                showSuccessModal={showSuccessModal}
                setShowSuccessModal={setShowSuccessModal}
                candidateId={candidateId}
                responseMessage={responseMessage}
            />
        )
      }
    </div>
  );
}

export default App;
